import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

const StateWiseOrdersChart = (props) => {
  const { finalData = [] } = props
  const pieData = finalData?.map((item) => ({
    name: item.state,
    y: Number(item.number_of_orders), // ensure it's a number
    totalAmount: Number(item.total_orders_amount)
  }))

  const options = {
    chart: {
      type: 'pie',
      height: 300,
      className: 'shadow-lg rounded-lg bg-white p-4'
    },
    title: {
      text: ''
    },
    tooltip: {
      formatter: function () {
        return `<b>${this.point.name}</b><br/>
                Number of Orders: <b>${this.point.y}</b><br/>
                Total Amount: <b>₹${this.point.totalAmount.toLocaleString()}</b>`
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '{point.name}: {point.y}',
          distance: 30,
          connectorShape: 'crookedLine',
          softConnector: true,
          style: {
            fontSize: '12px'
          }
        },
        showInLegend: false,
        size: '80%'
      }
    },
    series: [
      {
        name: 'Number of Orders',
        colorByPoint: true,
        data: pieData
      }
    ],
    colors: [
      '#3B82F6', // Blue
      '#10B981', // Green
      '#F59E0B', // Amber
      '#EF4444', // Red
      '#8B5CF6', // Violet
      '#EC4899', // Pink
      '#14B8A6', // Teal
      '#F97316' // Orange
    ],
    credits: {
      enabled: false
    }
  }

  return (
    <div className="flex h-[400px] items-center justify-center">
      <div className="mt-auto overflow-hidden">
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    </div>
  )
}

export default StateWiseOrdersChart
